export const mapObjects = {
  rule: 'Rule',
  variable: 'Value',
  experiment: 'Experiment',
  adjuster: 'Step',
  section: 'Section',
  accountdataset: 'Dataset',
  client: 'Client',
  account: 'Site',
};
